import styles from './Warehouse.module.css'

/**
 * LOGISPRD-15602 — 운영 플래그 스위치. `role="switch"` + `aria-checked` 이고, 색만으로 상태를 전하지 않도록 ON/OFF 글자를 함께 둔다.
 * 콘솔 `ui/` 에 스위치 프리미티브가 없고 이 탭만 쓰므로 탭 안에 둔다.
 */
export const Switch = ({
  checked,
  label,
  disabled,
  onChange,
}: {
  checked: boolean
  label: string
  disabled?: boolean
  onChange: (checked: boolean) => void
}): JSX.Element => (
  <button
    type="button"
    role="switch"
    aria-checked={checked}
    aria-label={label}
    className={styles.switch}
    disabled={disabled}
    onClick={() => onChange(!checked)}
  >
    <span className={styles.switchText}>{checked ? 'ON' : 'OFF'}</span>
    <span className={styles.switchTrack} aria-hidden="true">
      <span className={styles.switchThumb} />
    </span>
  </button>
)

/**
 * 미설정 운영 플래그 선택 — ON/OFF 라디오 2개. 처음엔 아무것도 선택되지 않아 사용자가 값을 직접 고르게 한다.
 * 스위치는 꺼짐이 곧 값이라 "아직 고르지 않음" 을 나타낼 수 없어 따로 둔다.
 */
export const FlagChoice = ({
  value,
  label,
  disabled,
  onChange,
}: {
  value: boolean | null
  label: string
  disabled?: boolean
  onChange: (value: boolean) => void
}): JSX.Element => (
  <div role="radiogroup" aria-label={label} className={styles.choice}>
    {[true, false].map((option) => (
      <button
        key={String(option)}
        type="button"
        role="radio"
        aria-checked={value === option}
        className={styles.choiceOption}
        disabled={disabled}
        onClick={() => onChange(option)}
      >
        {option ? 'ON' : 'OFF'}
      </button>
    ))}
  </div>
)
